import React, { Component } from "react";
import { Button, Modal } from "antd";
import { apiContract } from "../../../../../api/api-contract";
import { CONTRACT_STATUS } from "../../../../../common/utils/static-data";
import { alert } from "../../../../../common/utils/alert";

export class BottomButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "NEW",
    };
  }

  onChangeType = (type) => this.setState({ type });

  deleteContract = (type) => {
    let title = "";
    let content = "";
    let func = () => {};
    if (type === "DELETE") {
      title = "Xoá hợp đồng";
      content =
        "Bạn có chắc chắn muốn xoá hợp đồng không? Nếu xoá mọi thông tin về hợp đồng trước đó sẽ không được lưu trong hệ thống.";
      func = apiContract.deleteContract;
    } else {
      func = apiContract.cancelContract;
      title = "Huỷ hợp đồng";
      content =
        "Bạn có chắc chắn muốn huỷ hợp đồng không? Nếu huỷ mọi thông tin về hợp đồng sẽ được kết thúc.";
    }
    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: async () => {
        const { contractParam, close } = this.props;
        const result = await func(contractParam.id);
        if (result.status === "success") {
          alert("success", `${title} thành công!`);
          close();
        } else {
          alert("error", result.data.message);
        }
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  goBack = () => {
    let title = "Huỷ thao tác";
    let content =
      "Bạn có chắc chắn muốn quay lại? Nếu bạn quay lại mọi thông tin trước đó sẽ không được lưu.";

    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        this.props.close();
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  cancelEditContract = () => {
    let title = "Huỷ thao tác";
    let content =
      "Bạn có chắc chắn muốn quay lại? Nếu bạn quay lại mọi thông tin trước đó sẽ không được lưu.";

    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        this.props.cancelEditContract();
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  render() {
    const { type } = this.state;
    const {
      enableEditContract,
      contractParam,
      handleGoToEditHistory,
      submit,
    } = this.props;
    return (
      <div className="add-new-customer-container">
        {type === "NEW" ? (
          <>
            <Button
              style={{ marginRight: 10 }}
              onClick={this.goBack}
              className="add-new-customer cancel"
            >
              Huỷ
            </Button>
            <Button
              disabled={this.props.disabledOk}
              className="add-new-customer"
              onClick={submit}
            >
              Lưu
            </Button>
          </>
        ) : type === "EDIT" ? (
          <>
            <Button
              style={{ marginRight: 10 }}
              onClick={this.cancelEditContract}
              className="add-new-customer cancel"
            >
              Huỷ
            </Button>
            <Button
              disabled={this.props.disabledOk}
              className="add-new-customer"
              onClick={submit}
            >
              Lưu thay đổi
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={() => handleGoToEditHistory(true)}
              className="add-new-customer edit-history"
            >
              Lịch sử chỉnh sửa
            </Button>
            <Button
              disabled={
                contractParam.status == CONTRACT_STATUS.FINISHED ||
                contractParam.status == CONTRACT_STATUS.CANCELED
              }
              className="add-new-customer edit-button"
              onClick={enableEditContract}
            >
              Chỉnh sửa
            </Button>
            <Button
              disabled={
                contractParam.status !== CONTRACT_STATUS.WAITING_ASSIGN_CAR
              }
              className="add-new-customer del-contract"
              onClick={() => this.deleteContract("DELETE")}
            >
              Xoá HĐ
            </Button>
            <Button
              disabled={
                contractParam.status == CONTRACT_STATUS.FINISHED ||
                contractParam.status == CONTRACT_STATUS.CANCELED
              }
              className="add-new-customer cancel"
              onClick={() => this.deleteContract("CANCEL")}
            >
              Huỷ hợp đồng
            </Button>
          </>
        )}
      </div>
    );
  }
}
